import {Component} from '@angular/core';
import {GenRestorationMetricType} from '../../../../../../generated/serverModels/GenRestorationMetricType';
import {
  ResiliencyOverviewWidgetComponent,
} from '../widgets/resiliency-overview-widget/resiliency-overview-widget.component';
import {ResiliencyChartWidgetComponent} from '../widgets/resiliency-chart-widget/resiliency-chart-widget.component';

@Component({
  selector: 'tgrid-system-resilience-page',
  templateUrl: './system-resilience-page.component.html',
  styleUrls: ['./system-resilience-page.component.scss'],
  imports: [
    ResiliencyOverviewWidgetComponent,
    ResiliencyChartWidgetComponent,
  ],
})
export class SystemResiliencePageComponent {
  protected curveType = GenRestorationMetricType;
}
